import { Server } from '../../clients/aasServerClient.generated';
import * as actionCreators from './actionCreators';
import { ActionTypeNames } from './actions';

export interface State {
    table: Server[];
    all: Server[];
    singleServer: {
        loaded: boolean;
        saved: boolean;
        server?: Partial<Server>;
    };
}

const initialState: State = {
    all: [],
    singleServer: {
        loaded: false,
        saved: false,
        server: undefined,
    },
    table: [],
};

type Actions = ReturnType<typeof actionCreators[keyof typeof actionCreators]>;

export default function reducer(state: State = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypeNames.StoreTableServers:
            return {
                ...state,
                table: action.servers
            };
        case ActionTypeNames.StoreAllServers:
            return {
                ...state,
                all: action.servers,
            };
            case ActionTypeNames.ClearSingleServer:
            return {
                ...state,
                singleServer: {
                    loaded: false,
                    saved: false,
                    server: undefined,
                },
            };
        case ActionTypeNames.StoreSingleServer:
            return {
                ...state,
                singleServer: {
                    loaded: true,
                    saved: false,
                    server: action.server,
                },
            };
        case ActionTypeNames.SavedSingleServer:
            return {
                ...state,
                singleServer: {
                    ...state.singleServer,
                    saved: true,
                }
            };
        default:
            return state;
    }
}
